import React from 'react'
import "./Footer.css"
import { assets } from '../../assets/assets'


const Footer = () => {
  return (
    <div className='footer' id='footer'>

<div className="footer-content">

<div className="footer-contentr-left">

<img width={90} src={assets.logo} alt="Office Bites Delivery Order Online" />
<p>Envisioning seamless provision of clean, rich & aromatic khat right at your doorstep.</p>

            <div className="footer-social-icons">
            <img src={assets.facebook_icon} alt="" />
            <img src={assets.twitter_icon} alt="" />
            <img src={assets.linkedin_icon} alt="" />
            

            </div>

</div>


<div className="footer-content-right">
<h2>COMPANY</h2>

<ul>
   

   <li>Home</li>
   <li>About Us</li>
   <li>Delivery</li>
   <li>Privacy Policy</li>






</ul>



</div>
        <div className="footer-content-right">
        <h2>Get In Touch</h2>
        <ul>
        <li>+254-797-397-159</li>
            <li>aluta@rootzbaite.com</li>

        </ul>
        </div>
        
        </div>
        <hr />
        <p className='footer-copyright'>Copyright 2024 © Office Bites Ltd - All Rights Reserved.</p>
    </div>
  )
}

export default Footer
